import React from 'react';
import { useTranslation } from 'react-i18next';

import { Select, TextArea, Form } from '@weezevent/nacre';

export const ActionComment = React.memo(({ locale, action, isActive, setCommentAdded }) => {
    const { t } = useTranslation();
    const { comment_choices, comment_editable, comment_required } = action;
    const [customComment, setCustomComment] = React.useState('');
    const [commentChoice, setCommentChoice] = React.useState(null);

    const choicesOptions = React.useMemo(() => {
        if (!comment_choices.length) {
            return [];
        }
        const lng = locale?.replace('_', '-').toLowerCase() || 'en-gb';
        return comment_choices.map(choice => ({
            // nacre component wants this attribute names for options prop
            key: choice.id,
            text: choice.label,
            value: choice.translations.comment[lng]
        }));
    }, [comment_choices]);

    const handleChoice = React.useCallback((id, label, comment) => {
        const selected_comment = comment ? { id, label, comment } : null;
        setCustomComment('');
        setCommentChoice(selected_comment);
        action.comment = selected_comment;
        setCommentAdded(prev => [...prev, true]);
    }, []);

    const handleChange = value => {
        action.comment = value;
        setCustomComment(value);
        setCommentAdded(prev => [...prev, true]);
    };

    if (comment_required === null) return null;

    return (
        <>
            {!!comment_choices.length && isActive && (
                <Form.Field>
                    <Form.Label label={t('ticket.common.comment')} optionalText={!comment_required && t('ticket.common.labelOptionalParenthesis')} />
                    <Select
                        useNew
                        value={commentChoice?.comment}
                        onChange={(_, { key, text, value }) => handleChoice(key, text, value)}
                        onClear={() => handleChoice(null)}
                        options={choicesOptions}
                        placeholder={t('ticket.common.action.select')}
                    />
                </Form.Field>
            )}
            {isActive && (
                <Form.Field>
                    <Form.Label
                        label={t('ticket.moderation.attendee.moderationModal.addComment')}
                        optionalText={!comment_required && t('ticket.common.labelOptionalParenthesis')}
                    />
                    <TextArea value={customComment || commentChoice?.comment} onChange={({ target: { value } }) => handleChange(value)} disabled={!comment_editable} />
                </Form.Field>
            )}
        </>
    );
});
